import { useMediaQuery } from "react-responsive";
export const useMobile = () => useMediaQuery({ query: `(max-width: 768px)` });
export const useDesktopOrLaptop = () => useMediaQuery({ query: '(min-width: 1224px)' });
export const useBigScreen = () => useMediaQuery({ query: '(min-width: 1824px)' });
